module.exports = __webpack_public_path__ + "img/höhn a.57f3b1bd.jpg";